import React from "react";
import { Paper } from "@mui/material";
import { translate } from "../../../../../../common/providers";
import { Selector } from "../../../../../../common/components";
import styles from "./RedressDialog.module.css";

export default function RedressGroup({ action, handleChangeAction, GROUP_ACTION, isClause }) {
	const items = [!isClause && GROUP_ACTION[0], GROUP_ACTION[1]].filter(Boolean);
	const getLabel = (selected) =>
		translate(
			selected === GROUP_ACTION[0]
				? "smart-review.redress-group.item-content-above"
				: "smart-review.redress-group.item-content-below"
		);
	return (
		<div className={styles.container}>
			<Paper className={styles.paper}>
				<Selector
					className={styles.content}
					itemRenderer={getLabel}
					items={items}
					label={translate("smart-review.redress-group.item-group-with")}
					menuClassName={styles.select}
					value={action || (!isClause && GROUP_ACTION[0]) || GROUP_ACTION[1]}
					valueRenderer={getLabel}
					onChange={handleChangeAction}
				/>
			</Paper>
		</div>
	);
}
